export const BOOK_URL = "https://lagigafam.simplybook.it/v2/#book";
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_holistic-sport/artifacts/bxai2prq_Logo%20lagigafam.png";

export const IMAGES = {
  heroBg:
    "https://static.prod-images.emergentagent.com/jobs/a21bc982-3ee4-45c3-ab1b-9d0b5602e9bd/images/a2dac8ac80ed18c2a058e7f6e51b666853b3b64ccfecf259db47c50d2a0b361f.png",
  heroFitness:
    "https://customer-assets.emergentagent.com/job_holistic-sport/artifacts/nowwmtwa_Photo%20Perle%20Sport%20DKE_2266-ModifierFUHD.jpeg",
  lymphatic:
    "https://static.prod-images.emergentagent.com/jobs/a21bc982-3ee4-45c3-ab1b-9d0b5602e9bd/images/7b728151824ab95fa3bc9eec02de1ce2e36218c215f6a3ffa323cf88265bf6f7.png",
  equipment:
    "https://customer-assets.emergentagent.com/job_holistic-sport/artifacts/0szdzibh_Elastique%20lagigafam%20prototype.jpg",
  exercises:
    "https://customer-assets.emergentagent.com/job_holistic-sport/artifacts/qm79jg5n_3DD4E35E-55EA-464E-BAF4-3B65217855A3.PNG",
  facialMassage:
    "https://images.unsplash.com/photo-1706795033728-9232ef548a16?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
